import { render, staticRenderFns } from "./NewEditAlunoPage.vue?vue&type=template&id=af967ab8&scoped=true"
import script from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditAlunoPage.vue?vue&type=style&index=0&id=af967ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af967ab8",
  null
  
)

export default component.exports